import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Modal extends Component {
  componentDidMount() {
    this.modal.classList.add('in');
    this.modal.style.display = 'block';
  }

  onClose = () => {
    this.modal.classList.remove('in');
    this.modal.style.display = 'none';
  };

  render() {
    const { title, children } = this.props;
    return (
      <div
        role="dialog"
        className="modal"
        ref={el => {
          this.modal = el;
        }}
      >
        <div className="modal-backdrop custom-modal-backdrop" />
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header has-border">
              <button onClick={this.onClose} type="button" data-dismiss="modal" className="close">
                <span>×</span><span className="sr-only">Close</span>
              </button>
              <h4 className="modal-title">{title}</h4>
            </div>
            <div className="modal-body">
              <div className="row">
                <ul className="glossary-list">
                  {children}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired
};

export default Modal;



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/components/Modal/Modal.js